import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxPageScrollCoreModule } from '../../directives/ngx-page-scroll/ngx-page-scroll-core/ngx-page-scroll-core.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgScrollbarModule,
    InfiniteScrollDirective,
    ScrollingModule,
    NgxPageScrollCoreModule,
  ],
  exports: [
    NgScrollbarModule,
    InfiniteScrollDirective,
    ScrollingModule,
    NgxPageScrollCoreModule,
  ],
  providers: []
})
export class SmashScrollbarModule { }
